module.exports = __webpack_public_path__ + "static/media/ios.f76ce6ff.jpg";